<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full md:w-1/4">
        <vx-card class="overflow-hidden mb-4">
          <div slot="no-body">
            <div class="p-6 flex justify-between flex-row-reverse items-center">
              <span
                class="p-3 inline-flex rounded-full feather-icon select-none relative text-success mb-4"
                style="background: rgba(var(--vs-success),0.15);"
              >
                <i class="fas fa-money-bill-alt fa-2x"></i>
              </span>
              <div class="truncate">
                <h2 class="mb-1 font-bold">{{ totals.gross | money }} ({{ orders.total }})</h2>
                <span>Total do Período (Bruto)</span>
              </div>
            </div>
          </div>
        </vx-card>
      </div>

      <div class="vx-col w-full md:w-1/4">
        <vx-card class="overflow-hidden mb-4">
          <div slot="no-body">
            <div class="p-6 flex justify-between flex-row-reverse items-center">
              <span
                class="p-3 inline-flex rounded-full feather-icon select-none relative text-success mb-4"
                style="background: rgba(var(--vs-success),0.15);"
              >
                <i class="fas fa-money-bill-alt fa-2x"></i>
              </span>
              <div class="truncate">
                <h2 class="mb-1 font-bold">{{ totals.net | money }} ({{ orders.total }})</h2>
                <span>Total do Período (Líquido)</span>
              </div>
            </div>
          </div>
        </vx-card>
      </div>

      <div class="vx-col w-full md:w-1/4">
        <vx-card class="overflow-hidden mb-4">
          <div slot="no-body">
            <div class="p-6 flex justify-between flex-row-reverse items-center">
              <span
                class="p-3 inline-flex rounded-full feather-icon select-none relative text-success mb-4"
                style="background: rgba(var(--vs-success),0.15);"
              >
                <i class="fas fa-money-bill-alt fa-2x"></i>
              </span>
              <div class="truncate">
                <h2 class="mb-1 font-bold">{{ totals.fee | money }}</h2>
                <span>Total do Período (Taxas)</span>
              </div>
            </div>
          </div>
        </vx-card>
      </div>

      <div class="vx-col w-full md:w-1/4">
        <vx-card class="overflow-hidden mb-4">
          <div slot="no-body">
            <div class="p-6 flex justify-between flex-row-reverse items-center">
              <span
                class="p-3 inline-flex rounded-full feather-icon select-none relative text-danger mb-4"
                style="background: rgba(var(--vs-danger),0.15);"
              >
                <i class="fas fa-money-bill-alt fa-2x"></i>
              </span>
              <div class="truncate">
                <h2 class="mb-1 font-bold">{{ totals.refunds | money }} ({{ totals.refundsCount }})</h2>
                <span>Devoluções do Período</span>
              </div>
            </div>
          </div>
        </vx-card>
      </div>
    </div>

    <div id="data-list-list-view" class="data-list-container mt-5">
      <div class="flex mb-4 px-2">
        <div class="flex-1 px-2">
          <vs-input class="w-100 inputx" placeholder="Número" v-model="filters.number"/>
        </div>
        <div class="flex-1 px-2">
          <vs-input class="w-100 inputx" placeholder="E-mail" v-model="filters.email"/>
        </div>
        <div class="flex-1 px-2">
          <vs-input class="w-100 inputx" placeholder="CPF/CNPJ" v-model="filters.cpfcnpj"/>
        </div>
        <div class="flex-1 px-2">
          <Datepicker
            :language="ptBR"
            :clear-button="true"
            placeholder="Data Inicial"
            :use-utc="true"
            format="dd/MM/yyyy"
            v-model="filters.created_at.start"
          />
        </div>
        <div class="flex-1 px-2">
          <Datepicker
            :language="ptBR"
            :clear-button="true"
            placeholder="Data Final"
            :use-utc="true"
            format="dd/MM/yyyy"
            v-model="filters.created_at.end"/>
        </div>
        <div class="flex-1 px-2">
          <v-select
            multiple
            :closeOnSelect="false"
            v-model="filters.payment_method.selected"
            :options="filters.payment_method.options"
            placeholder="Pagamento"
          />
        </div>
      </div>

      <div class="flex justify-center">
        <div>
          <vs-pagination :max="10" :total="orders.last_page" v-model="orders.current_page"></vs-pagination>
        </div>
      </div>

      <vs-table
        ref="table"
        noDataText="Nenhum item encontrado no período selecionado"
        :data="data"
        :sst="true"
        :stripe="true"
      >
        <template slot="thead">
          <vs-th>DATA/HORA</vs-th>
          <vs-th>BRUTO</vs-th>
          <vs-th>TARIFA</vs-th>
          <vs-th>LÍQUIDO</vs-th>
          <vs-th>EMAIL</vs-th>
          <vs-th>ID TRANSAÇÃO</vs-th>
          <vs-th>NÚMERO</vs-th>
          <vs-th>PAGAMENTO</vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr :data="tr" v-for="(tr, idx) in data" :key="idx">
            <vs-td :data="data[idx].created_at">
              <div>{{ data[idx].created_at | formatDate }}</div>
              <div>{{ data[idx].created_at | formatTime }}</div>
            </vs-td>
            <vs-td :data="data[idx].subtotal">{{ data[idx].subtotal | money }}</vs-td>
            <vs-td :data="data[idx].fee">{{ data[idx].fee | money }}</vs-td>
            <vs-td :data="data[idx].total">{{ data[idx].total | money }}</vs-td>
            <vs-td v-if="data[idx].user" :data="data[idx].user.email">
              <router-link
                :to="{ name: 'cliente-detalhes', params: { id: data[idx].user.id } }"
              >{{ data[idx].user.email }}
              </router-link>
            </vs-td>
            <vs-td>
              <span v-for="payment in data[idx].payments" :key="payment.id">
                <span v-if="payment.transaction_id.indexOf('I-') > -1">
                  <a
                    :href="'https://www.paypal.com/billing/subscriptions/' + payment.transaction_id"
                    target="_blank"
                  >{{ payment.transaction_id }}</a>
                </span>
                <span v-else-if="data[idx].payment_method.indexOf('Cartão') > -1 || data[idx].payment_method.indexOf('PayPal') > -1">
                  <a
                    :href="'https://www.paypal.com/activity/payment/' + payment.transaction_id"
                    target="_blank"
                  >{{ payment.transaction_id }}</a>
                </span>
                <span v-else>{{ payment.transaction_id || '-' }}</span>
              </span>
            </vs-td>
            <vs-td :data="data[idx].number">
              <router-link :to="{ name: 'venda-detalhes', params: { id: data[idx].id } }">{{ data[idx].number }}</router-link>
            </vs-td>
            <vs-td :data="data[idx].payment_method">{{ data[idx].payment_method }}</vs-td>
          </vs-tr>
        </template>
      </vs-table>

      <div class="flex justify-center">
        <div>
          <vs-pagination :max="10" :total="orders.last_page" v-model="orders.current_page"></vs-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import Datepicker from 'vuejs-datepicker'
import {ptBR} from 'vuejs-datepicker/dist/locale'

export default {
  components: {
    'v-select': vSelect,
    Datepicker
  },
  data() {
    return {
      ptBR,
      orders: {
        current_page: 1,
        last_page: 1
      },
      filters: {
        created_at: {
          start: null,
          end: null
        },
        payment_method: {
          options: [
            'Boleto',
            'Cartão de Crédito',
            'PayPal-Order',
            'PayPal-Subscription',
            'Transferência'
          ],
          selected: []
        }
      },
      data: [],
      totals: {
        total: 0,
        refunds: 0,
        avg: 0
      },
      timeout: null
    }
  },

  mounted() {
    const filters = JSON.parse(
      localStorage.getItem(`filters-${this.$route.fullPath}`)
    )

    if (filters) {
      this.filters = filters
    }

    const query = this.$route.query
    if (query.payment_method) {
      this.filters.payment_method.selected = [query.payment_method]
    }

    if (query.status) {
      this.filters.status.selected = [query.status]
    }

    if (query['created_at.start'] && query['created_at.end']) {
      this.filters.created_at.start = query['created_at.start']
      this.filters.created_at.end = query['created_at.end']
    } else if (!this.filters.created_at.start) {
      this.filters.created_at.start = new Date()
      this.filters.created_at.end = new Date()
    }

    this.load()
  },

  methods: {
    load() {
      this.$vs.loading()

      localStorage.setItem(
        `filters-${this.$route.fullPath}`,
        JSON.stringify(this.filters)
      )

      this.$api
      .get('/api/v1/backend/reconciliation', {
        params: {
          page: this.orders.current_page,
          filters: this.filters
        }
      })
      .then((response) => {
        this.$vs.loading.close()
        this.data = response.data.orders.data
        this.orders = response.data.orders
        this.totals = response.data.totals
      })
    }
  },

  watch: {
    filters: {
      handler() {
        clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {
          this.load()
        }, 600)
      },
      deep: true
    },
    'orders.current_page'() {
      this.load()
    }
  }
}
</script>

<style lang="scss">
#data-list-list-view {
  .vs-con-table {
    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;

      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);

        td {
          padding: 20px;

          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }

          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }

        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          bg-transform: uppercase;
          font-weight: 600;
        }
      }

      th.td-check {
        padding: 0 15px !important;
      }

      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
